import ajaxRequest from './ajax'
import qs from "qs"

//增加操作日志的接口 只需要传module/object
export const add_action_log = params => {
  return ajaxRequest.post("common/actionlog/add_action_log", params)
}




// WEBPACK FOOTER //
// ./src/api/common.js